export enum AccessibilityTypes {
  AUDIO_DESCRIPTION = 'AUDIO_DESCRIPTION',
  SIGN_LANGUAGE = 'SIGN_LANGUAGE',
  SUBTITLES = 'SUBTITLES',
}

export const AccessibilityIcons = {
  [AccessibilityTypes.SUBTITLES]: 'images/accessibility/subtitles.png',
  [AccessibilityTypes.AUDIO_DESCRIPTION]: 'images/accessibility/audio_description.png',
  [AccessibilityTypes.SIGN_LANGUAGE]: 'images/accessibility/sign_language.png',
};
